import React, { useContext } from 'react';

import { ModalCloseButton } from '@vimeo/bokeh';

import TrackingContext from './TrackingContext';
import BpTracking from '../../utils/bpTracking';

interface DismissIconProps {
  onClose: VoidFunction;
  margin?: string;
}

const DismissIcon = (props: DismissIconProps) => {
  const trackingProps = useContext(TrackingContext);

  const handleClose = () => {
    BpTracking.trackDismiss(
      {
        ...trackingProps.params,
        device_type: trackingProps.device_type,
      },
      trackingProps.bpEventVersion,
    );

    if (trackingProps.onClose) {
      trackingProps.onClose();
    }

    props.onClose();
  };

  return (
    <>
      <ModalCloseButton
        data-testid="close-upsell-button"
        margin={props?.margin}
        zIndex={1750}
        onClick={handleClose}
      />
    </>
  );
};

export default DismissIcon;
